import React from "react";
// import { css } from 'aphrodite';
import {
  ContentRow,
  Switch,
  ContentCard,
  StandardInput,
  GreenButton,
  RedButton
} from "../../common";
import { PERMISSION_TYPES } from "../../../library/constants";
// import AppStyles from "../../../library/appStyles"

// import styles from "./users-form-styles"

const UsersFormView = props => (
  <ContentCard title={"Add User"}>
    <ContentRow>
      <StandardInput
        placeholder={"Email"}
        onChange={props.onChangeEmail}
        value={props.email}
      />
      <div style={{ flex: 1 }} />
    </ContentRow>
    {PERMISSION_TYPES.map(item => {
      return (
        <ContentRow key={item.key}>
          <div>{item.narration}</div>
          <div style={{ flex: 1 }} />
          <Switch
            checked={props[item]}
            onChange={() => props.onPermissionToggle(item.key)}
          />
        </ContentRow>
      );
    })}
    <ContentRow>
      <RedButton title={"Cancel"} onClick={props.onCancelPress} />
      <div style={{ flex: 1 }} />
      <GreenButton title={"Add"} onClick={props.onAddPress} />
    </ContentRow>
  </ContentCard>
);

export default UsersFormView;



// WEBPACK FOOTER //
// ./src/components/users-and-permissions/users-form/users-form-view.js